import React from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import ReactDOMServer from "react-dom/server";
import { AppNotificationAlert, AppRemixIcon } from "@/layout/AppComponents";
import AppModal from "../../../..//components/Modal/AppModal";
import Translator from "../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../routing/helpers/router";
import { Field, Formik } from "formik";
import { useParams } from "react-router-dom";
import * as currentPageAction from "@/store/actions/currentPageAction";

const IntelligenceModalProfileSave = (props) => {
  const { showSaveProfileModal, setShowSaveProfileModal, valuesToProfile } =
    props;
  const { moduleBridgeHex } = useParams();

  const dispatch = useDispatch();

  const handleSaveProfile = async (formName) => {
    await axios
      .post(axiosPath("api_r_user_m_intelligence_crudProfile"), {
        form: formName,
        values: valuesToProfile,
        moduleBridgeHex,
      })
      .then(({ data }) => {
        dispatch(
          currentPageAction.change(
            "intelligenceProfiles",
            data.intelligenceProfiles,
            true,
          ),
        );
        setShowSaveProfileModal(false);
        AppNotificationAlert({
          title: ReactDOMServer.renderToString(
            <Translator file="module-intelligence" name="created" />,
          ),
          message: ReactDOMServer.renderToString(
            <Translator file="module-intelligence" name="profile.saved" />,
          ),
          type: "success",
        });
      })
      .catch(() => {
        AppNotificationAlert({
          title: ReactDOMServer.renderToString(
            <Translator file="user" name="user.error" />,
          ),
          message: ReactDOMServer.renderToString(
            <Translator
              file="module-intelligence"
              name="existing.name.choose.another"
            />,
          ),
          type: "danger",
        });
      });
  };

  return (
    <>
      <AppModal
        show={showSaveProfileModal}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-intelligence"
            name="module.int.save-profile"
          />,
        )}
        onClose={() => setShowSaveProfileModal(false)}
      >
        <Formik
          initialValues={{
            mode: "create",
            newProfileName: "",
          }}
          onSubmit={handleSaveProfile}
        >
          {({ handleSubmit }) => (
            <>
              <div className="row">
                <div className="col-sm-2 col-md-12 col-lg-3 col-xl-2">
                  <label className="col-form-label">
                    <Translator file="module-intelligence" name="name" />
                  </label>
                </div>
                <div className="col-sm-10 col-md-12 col-lg-9 col-xl-10">
                  <Field name="newProfileName" className="form-control mb-2" />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <span
                    className="btn btn-info btn-block"
                    onClick={handleSubmit}
                  >
                    <Translator file="module-intelligence" name="save" />
                  </span>
                </div>
              </div>
            </>
          )}
        </Formik>
      </AppModal>
    </>
  );
};

export default IntelligenceModalProfileSave;
